import { SafeHTMLPipe } from './../../pipes/safeHTML.pipe';
import { FilterPipe } from './../../pipes/filter.pipe';
import { TitlePipe } from './../../pipes/title.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [CommonModule],
  declarations: [TitlePipe, FilterPipe, SafeHTMLPipe],
  exports: [TitlePipe, FilterPipe, SafeHTMLPipe],
})
export class SharedModule {}
